/** True while the canvas document is being restored from the saved board. */
export const canvasDocumentHydrating = { active: false };
